import RichText from '@eneco/components/RichText/RichText';
import { Accordion } from '@eneco/sparky';
import { PreDeliveryFAQCard, FaqCard as DeliveryFaqCard } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const FaqCard = ({ fields }: { fields: PreDeliveryFAQCard | DeliveryFaqCard }) => {
  return (
    <StyledDashboardBlock>
      <Accordion>
        {fields?.questionOneText?.value && fields?.answerOneContent?.value && (
          <Accordion.Item heading={fields?.questionOneText?.value} id="q1">
            <RichText html={fields?.answerOneContent?.value} />
          </Accordion.Item>
        )}
        {fields?.questionTwoText?.value && fields?.answerTwoContent?.value && (
          <Accordion.Item heading={fields?.questionTwoText?.value} id="q2">
            <RichText html={fields?.answerTwoContent?.value} />
          </Accordion.Item>
        )}
        {fields?.questionThreeText?.value && fields?.answerThreeContent?.value && (
          <Accordion.Item heading={fields?.questionThreeText?.value} id="q3">
            <RichText html={fields?.answerThreeContent?.value} />
          </Accordion.Item>
        )}
        {fields?.questionFourText?.value && fields?.answerFourContent?.value && (
          <Accordion.Item heading={fields?.questionFourText?.value} id="q4">
            <RichText html={fields?.answerFourContent?.value} />
          </Accordion.Item>
        )}
      </Accordion>

      {fields?.changeLink?.value?.text && fields?.changeLink?.value?.href && (
        <DashboardLink
          href={fields?.changeLink?.value?.href}
          emphasis="high"
          trackingComponentName="faq_card_change_link"
          trackingComponentType="dashboard_link">
          {fields?.changeLink?.value?.text}
        </DashboardLink>
      )}
    </StyledDashboardBlock>
  );
};
